/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {StickyHeaderBaseComponent} from './sticky-header-base.component';

export class StickyHeaderSearchComponent implements StickyHeaderBaseComponent {
}
